// Lowest Grade Page
import React from 'react';

const LowestGradePage = () => {
  // Manual lowest grade as specified by user
  const lowestGrade = "81.42";

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh', fontFamily: 'monospace', fontSize: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {lowestGrade}
    </div>
  );
};

export default LowestGradePage;
